module.exports = __webpack_public_path__ + "static/media/human-scale.8701d67b.png";